module.exports = __webpack_public_path__ + "img/biodiversity2.b283b48a.png";